/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AppVersionCheckResponse {
  isSupported?: boolean;
  isUpdateRequired?: boolean;
  latestVersion?: string | null;
  minimumSupportedVersion?: string | null;
  platform?: string | null;
  updateUrl?: string | null;
  message?: string | null;
}

export interface BayPreferenceRequest {
  bayPreference?: string | null;
  permitNumber?: string | null;
}

export interface BayPreferenceResponse {
  bayPreference?: string | null;
  permitNumber?: string | null;
}

export interface CancelReservationResponse {
  /** @format uuid */
  id?: string;
  status?: string | null;
  error?: string | null;
  isActive?: boolean;
}

export interface CardDetails {
  brand?: string | null;
  last4?: string | null;
  /** @format int32 */
  expMonth?: number;
  /** @format int32 */
  expYear?: number;
}

export interface ConfigResponse {
  googleMapsApi?: string | null;
}

export interface CreateReservationResponse {
  /** @format uuid */
  id?: string;
  status?: string | null;
  error?: string | null;
  isActive?: boolean;
  /** @format double */
  price?: number;
}

export interface CustomerPortalResponse {
  url?: string | null;
}

export interface PaymentMethodResponse {
  id?: string | null;
  type?: string | null;
  card?: CardDetails;
  isDefault?: boolean;
}

export interface PaymentMethodsListResponse {
  paymentMethods?: PaymentMethodResponse[] | null;
  defaultPaymentMethodId?: string | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface ProfileResponse {
  /** @format uuid */
  id?: string;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** Uid used to create the QrCode for parking access, this can be re-issued if needed */
  uid?: string | null;
  mobile?: string | null;
  streetName?: string | null;
  streetNumber?: string | null;
  streetType?: string | null;
  suburb?: string | null;
  state?: string | null;
  postcode?: string | null;
  notificationType?: string | null;
  agreeTermsConditions?: boolean;
  stripeMetadata?: string | null;
  bayPreference?: string | null;
  permitNumber?: string | null;
  validationErrors?: Record<string, string | null>;
  notifyByEmail?: boolean;
  notifyBySms?: boolean;
  notifyReservationReminders?: boolean;
  notifyPaymentReceipts?: boolean;
  notifyMarketingEmails?: boolean;
}

export interface ReservationProduct {
  name?: string | null;
  description?: string | null;
}

export interface ReservationRequest {
  /** @format uuid */
  siteId?: string;
  /** @format uuid */
  vehicleId?: string;
  vehiclePlate?: string | null;
  visitorName?: string | null;
  visitorPhone?: string | null;
  /** @format date-time */
  startDate?: string;
  startTime?: string | null;
  /** @format date-time */
  endDate?: string;
  endTime?: string | null;
  city?: string | null;
  bayType?: string | null;
  /** Indicates who the booking is for: "self" or "visitor" */
  bookingFor?: string | null;
}

export interface ReservationResponse {
  /** @format uuid */
  id?: string;
  startDate?: string | null;
  startTime?: string | null;
  endDate?: string | null;
  endTime?: string | null;
  /** @format uuid */
  siteId?: string | null;
  siteName?: string | null;
  siteAddress?: string | null;
  siteTimezone?: string | null;
  /** @format int32 */
  siteGracePeriod?: number | null;
  /** @format uuid */
  vehicleId?: string | null;
  vehiclePlate?: string | null;
  visitorName?: string | null;
  visitorPhone?: string | null;
  city?: string | null;
  status?: string | null;
  error?: string | null;
  /** @format double */
  price?: number | null;
  type?: string | null;
}

export interface ReservationStatusResponse {
  status?: string | null;
  statusMessage?: string | null;
  isPermanentParker?: boolean;
  /** @format double */
  price?: number | null;
  error?: string | null;
  products?: ReservationProduct[] | null;
}

export interface SetupIntentResponse {
  customerId?: string | null;
  ephemeralKey?: string | null;
  setupIntent?: string | null;
  publishableKey?: string | null;
  shouldSetAsDefault?: boolean;
}

export interface SiteResponse {
  /** @format uuid */
  id?: string;
  name?: string | null;
  address?: string | null;
  timeZone?: string | null;
  city?: string | null;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  /** @format int32 */
  currentCapacity?: number;
  bayTypes?: string[] | null;
  /**
   * Access types available to the user for this site.
   * Possible values: "public" (default for listed sites), "permanent" (user has permanent parker access)
   */
  accessTypes?: string[] | null;
}

export interface TransactionEvent {
  /** @format date-time */
  createdUtc?: string | null;
  message?: string | null;
  type?: string | null;
}

export interface TransactionInvoice {
  /** @format uuid */
  id?: string;
  status?: string | null;
  number?: string | null;
  url?: string | null;
}

export interface TransactionResponse {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  startUtc?: string | null;
  /** @format date-time */
  endUtc?: string | null;
  siteName?: string | null;
  isPerm?: boolean;
  type?: string | null;
  /** @format double */
  amount?: number | null;
  status?: string | null;
  /** @format double */
  duration?: number;
  events?: TransactionEvent[] | null;
  invoices?: TransactionInvoice[] | null;
}

export interface UpdateProfileRequest {
  firstName?: string | null;
  lastName?: string | null;
  mobile?: string | null;
  streetName?: string | null;
  streetNumber?: string | null;
  streetType?: string | null;
  suburb?: string | null;
  state?: string | null;
  postcode?: string | null;
  notificationType?: string | null;
  agreeTermsConditions?: boolean | null;
  bayPreference?: string | null;
  permitNumber?: string | null;
  notifyByEmail?: boolean | null;
  notifyBySms?: boolean | null;
  notifyReservationReminders?: boolean | null;
  notifyPaymentReceipts?: boolean | null;
  notifyMarketingEmails?: boolean | null;
}

export interface ValidationProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: Record<string, string[]>;
  [key: string]: any;
}

export interface VehicleRequest {
  plate?: string | null;
  make?: string | null;
  model?: string | null;
  colour?: string | null;
  state?: string | null;
  isElectric?: boolean;
}

export interface VehicleResponse {
  /** @format uuid */
  id?: string;
  plate?: string | null;
  make?: string | null;
  model?: string | null;
  colour?: string | null;
  state?: string | null;
  isActive?: boolean;
  isElectric?: boolean;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<
  D extends unknown,
  E extends unknown = unknown,
> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response.clone() as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Share Park API
 * @version v1
 * @contact Share Park Support <support@sharepark.net>
 *
 * API for Share Park mobile and web applications
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags v1
     * @name V1ProfileList
     * @summary Get the profile information for the current user.
     * @request GET:/api/v1/profile
     * @secure
     */
    v1ProfileList: (params: RequestParams = {}) =>
      this.request<ProfileResponse, ProblemDetails>({
        path: `/api/v1/profile`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1ProfileUpdate
     * @summary Updates the profile for the current user.
     * @request PUT:/api/v1/profile
     * @secure
     */
    v1ProfileUpdate: (data: UpdateProfileRequest, params: RequestParams = {}) =>
      this.request<ProfileResponse, ProblemDetails>({
        path: `/api/v1/profile`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint permanently anonymizes the user's account data including: - Personal information (name, email, phone, address) - Payment methods (removed from Stripe) - Vehicles (deactivated) - Reservations and transaction history (anonymized) This action cannot be undone. The user will need to create a new account to use the service again.
     *
     * @tags v1
     * @name V1ProfileDelete
     * @summary Deletes the current user's account and anonymizes all associated data
     * @request DELETE:/api/v1/profile
     * @secure
     */
    v1ProfileDelete: (params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/v1/profile`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This endpoint allows the user to update their preferred parking bay.
     *
     * @tags v1
     * @name V1ProfileBayPreferenceUpdate
     * @summary Updates the bay preference for the authenticated user.
     * @request PUT:/api/v1/profile/bay-preference
     * @secure
     */
    v1ProfileBayPreferenceUpdate: (
      data: BayPreferenceRequest,
      params: RequestParams = {},
    ) =>
      this.request<BayPreferenceResponse, ProblemDetails>({
        path: `/api/v1/profile/bay-preference`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows the user to request a new QR code, which can be used for parking validation.
     *
     * @tags v1
     * @name V1QrCodeReissueCreate
     * @summary Reissues a new QR code for the authenticated user.
     * @request POST:/api/v1/qr-code/reissue
     * @secure
     */
    v1QrCodeReissueCreate: (params: RequestParams = {}) =>
      this.request<ProfileResponse, ProblemDetails>({
        path: `/api/v1/qr-code/reissue`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows the user to view their existing parking reservations.
     *
     * @tags v1
     * @name V1ReservationsList
     * @summary Retrieves the parking reservations for the authenticated user.
     * @request GET:/api/v1/reservations
     * @secure
     */
    v1ReservationsList: (params: RequestParams = {}) =>
      this.request<ReservationResponse[], ProblemDetails>({
        path: `/api/v1/reservations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows users to create parking reservations. The reservation will be validated for availability and pricing before creation. If successful, returns the updated user profile. Sample request: POST /api/v1/reservations { "siteId": "3fa85f64-5717-4562-b3fc-2c963f66afa6", "vehicleId": "3fa85f64-5717-4562-b3fc-2c963f66afa6", "startDate": "2023-12-25", "startTime": "09:00", "endDate": "2023-12-25", "endTime": "17:00", "city": "Sydney", "bayType": "standard" }
     *
     * @tags v1
     * @name V1ReservationsCreate
     * @summary Creates a new parking reservation for the authenticated user.
     * @request POST:/api/v1/reservations
     * @secure
     */
    v1ReservationsCreate: (
      data: ReservationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        CreateReservationResponse,
        ValidationProblemDetails | ProblemDetails
      >({
        path: `/api/v1/reservations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint calculates the cost and validates availability for a parking reservation without actually creating it. Use this before calling the create reservation endpoint to show users pricing information and check availability. Response will include: - Total price for the reservation - Availability status - Whether user is a permanent parker (affects pricing) - Any validation errors or conflicts
     *
     * @tags v1
     * @name V1ReservationsCalculateCreate
     * @summary Calculate pricing and availability for a potential parking reservation.
     * @request POST:/api/v1/reservations/calculate
     * @secure
     */
    v1ReservationsCalculateCreate: (
      data: ReservationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        ReservationStatusResponse,
        ValidationProblemDetails | ProblemDetails
      >({
        path: `/api/v1/reservations/calculate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Cancels an existing parking reservation. The reservation must belong to the authenticated user and be in a cancellable state. Some reservations may not be cancellable depending on timing and site policies.
     *
     * @tags v1
     * @name V1ReservationsCancelUpdate
     * @summary Cancel a specific parking reservation.
     * @request PUT:/api/v1/reservations/{id}/cancel
     * @secure
     */
    v1ReservationsCancelUpdate: (id: string, params: RequestParams = {}) =>
      this.request<
        CancelReservationResponse,
        ValidationProblemDetails | ProblemDetails
      >({
        path: `/api/v1/reservations/${id}/cancel`,
        method: "PUT",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows anonymous access to retrieve a specific reservation using a visitor ID (short GUID).
     *
     * @tags v1
     * @name V1VisitorDetail
     * @summary Retrieves a reservation by visitor ID.
     * @request GET:/api/v1/visitor/{visitorId}
     */
    v1VisitorDetail: (visitorId: string, params: RequestParams = {}) =>
      this.request<ReservationResponse, ProblemDetails>({
        path: `/api/v1/visitor/${visitorId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows users to view all available parking sites. If the user is authenticated, sites they have permanent parker access to will include "permanent" in AccessTypes. All listed sites include "public" in AccessTypes by default.
     *
     * @tags v1
     * @name V1SitesList
     * @summary Retrieves the available parking sites.
     * @request GET:/api/v1/sites
     * @secure
     */
    v1SitesList: (params: RequestParams = {}) =>
      this.request<SiteResponse[], ProblemDetails>({
        path: `/api/v1/sites`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows the user to view their parking transaction history.
     *
     * @tags v1
     * @name V1TransactionsList
     * @summary Retrieves the parking transactions for the authenticated user.
     * @request GET:/api/v1/transactions
     * @secure
     */
    v1TransactionsList: (
      query?: {
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TransactionResponse[], ProblemDetails>({
        path: `/api/v1/transactions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows the user to view all their registered vehicles.
     *
     * @tags v1
     * @name V1VehiclesList
     * @summary Retrieves the vehicles for the authenticated user.
     * @request GET:/api/v1/vehicles
     * @secure
     */
    v1VehiclesList: (params: RequestParams = {}) =>
      this.request<VehicleResponse[], ProblemDetails>({
        path: `/api/v1/vehicles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows the user to add a new vehicle to their account.
     *
     * @tags v1
     * @name V1VehiclesCreate
     * @summary Creates a new vehicle for the authenticated user.
     * @request POST:/api/v1/vehicles
     * @secure
     */
    v1VehiclesCreate: (data: VehicleRequest, params: RequestParams = {}) =>
      this.request<VehicleResponse, ValidationProblemDetails | ProblemDetails>({
        path: `/api/v1/vehicles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows the user to modify the details of an existing vehicle.
     *
     * @tags v1
     * @name V1VehiclesUpdate
     * @summary Updates an existing vehicle for the authenticated user.
     * @request PUT:/api/v1/vehicles/{id}
     * @secure
     */
    v1VehiclesUpdate: (
      id: string,
      data: VehicleRequest,
      params: RequestParams = {},
    ) =>
      this.request<VehicleResponse, ValidationProblemDetails | ProblemDetails>({
        path: `/api/v1/vehicles/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows the user to remove a vehicle from their account. The vehicle will be marked as inactive rather than permanently deleted.
     *
     * @tags v1
     * @name V1VehiclesDelete
     * @summary Deletes a vehicle for the authenticated user.
     * @request DELETE:/api/v1/vehicles/{id}
     * @secure
     */
    v1VehiclesDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, ProblemDetails>({
        path: `/api/v1/vehicles/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * @description This endpoint allows users to view the application's configuration settings.
     *
     * @tags v1
     * @name V1ConfigList
     * @summary Retrieves the configuration settings for the application.
     * @request GET:/api/v1/config
     */
    v1ConfigList: (params: RequestParams = {}) =>
      this.request<ConfigResponse, any>({
        path: `/api/v1/config`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description This endpoint allows users to view the details of a specific invoice.
     *
     * @tags v1
     * @name V1InvoicesDetail
     * @summary Retrieves the invoice details for a specific invoice.
     * @request GET:/api/v1/invoices/{id}
     * @secure
     */
    v1InvoicesDetail: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/invoices/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description This endpoint creates: 1. A Stripe Customer (or retrieves existing) 2. An Ephemeral Key for the customer 3. A SetupIntent for collecting payment details
     *
     * @tags v1
     * @name V1SetupIntentsCreate
     * @summary Creates a SetupIntent for collecting payment method details (for mobile apps using Stripe native SDK)
     * @request POST:/api/v1/setup-intents
     * @secure
     */
    v1SetupIntentsCreate: (
      query?: {
        /**
         * Stripe API version (optional, passed from mobile SDK)
         * @default ""
         */
        apiVersion?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SetupIntentResponse, ProblemDetails | void>({
        path: `/api/v1/setup-intents`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1StripePaymentMethodsList
     * @summary Retrieves all payment methods for the current user
     * @request GET:/api/v1/stripe/payment-methods
     * @secure
     */
    v1StripePaymentMethodsList: (params: RequestParams = {}) =>
      this.request<PaymentMethodsListResponse, ProblemDetails>({
        path: `/api/v1/stripe/payment-methods`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1StripePaymentMethodsDefaultCreate
     * @summary Sets a payment method as the default for the current user
     * @request POST:/api/v1/stripe/payment-methods/{id}/default
     * @secure
     */
    v1StripePaymentMethodsDefaultCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<PaymentMethodResponse, ProblemDetails>({
        path: `/api/v1/stripe/payment-methods/${id}/default`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1StripePaymentMethodsDetachDelete
     * @summary Removes a payment method from the current user's account
     * @request DELETE:/api/v1/stripe/payment-methods/{id}/detach
     * @secure
     */
    v1StripePaymentMethodsDetachDelete: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, ProblemDetails>({
        path: `/api/v1/stripe/payment-methods/${id}/detach`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
 * No description
 *
 * @tags v1
 * @name V1StripeCustomerPortalCreate
 * @summary Creates a Stripe Customer Portal session for managing billing and payment methods
Supports both web URLs and app deep links (e.g., sharepark://)
 * @request POST:/api/v1/stripe/customer-portal
 * @secure
 */
    v1StripeCustomerPortalCreate: (
      query?: {
        /** Optional return URL after the customer exits the portal (defaults to public app URL). Can be a deep link. */
        returnUrl?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CustomerPortalResponse, ProblemDetails>({
        path: `/api/v1/stripe/customer-portal`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1StripeCustomerPortalRedirectList
     * @summary Redirect endpoint for Stripe Customer Portal to handle app deep links
     * @request GET:/api/v1/stripe/customer-portal-redirect
     */
    v1StripeCustomerPortalRedirectList: (
      query?: {
        /** The session token */
        session?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/stripe/customer-portal-redirect`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags v1
     * @name V1AppVersionCheckList
     * @summary Checks if the app version is supported and if an update is required
     * @request GET:/api/v1/app-version/check
     */
    v1AppVersionCheckList: (
      query?: {
        /** Platform (e.g. ios, android) */
        platform?: string;
        /** App version string (e.g. 1.2.3) */
        version?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AppVersionCheckResponse, any>({
        path: `/api/v1/app-version/check`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
